'use strict';

bbw.model.Lang = ngtk.model.Base.extend({

    _data: null,

    _initialize: function() {
        this._data = {};
    },

    loadLang: function(key) {
        return this._loadFromApi('get', 'lang/get/' + key).then(this._onLoaded.bind(this));
    },

    loadAttrLists: function(key, with_order) {
        return this._loadFromApi('get', 'lang/attrlists/' + key + (with_order ? '/1' : '')).then(this._onLoaded.bind(this));
    },

    get: function() {
        return this._data;
    },

    _onLoaded: function(result) {
        if (!angular.isObject(result)) {
            result = {};
        }
        ngtk.tools.object.replace(this._data, result);
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        scopeInnerPtr[scopeInnerElement] = this._data;
    }

});